interface Item {
    id: number | null;
    nome: string;
}

export function extrairIds(array: Item[]): number[] {
    return array.map(item => item.id || 0);
}
interface ItemLabel {
    id: number;
    label: string;
}

export function extrairIdsComLabel(array: ItemLabel[]): number[] {
    return array.map(item => item.id || 0);
}